import { RG_TYPE } from '../../types/rg-type.js';

/**
 * Calculates the maximum module depth from a set of apartments.
 * The module depth is calculated from the apartment's position on the corridor
 * (where it is to be placed during aggregation)
 * @param apartments The set of apartments to calculate the max module depth from
 * @returns the module depth
 */
function getMaxModuleDepth(apartments) {
    let maxDepth = 0;
    for (const apartment of apartments) {
        const modules = apartment.children.filter(c => c.type === RG_TYPE.Module);
        for (const module of modules) {
            const depthOrigin = (module.size[2] * module.anchor[2]) + module.pos[2];
            maxDepth = Math.max(maxDepth, module.size[2] - Math.abs(depthOrigin));
        }
    }
    return maxDepth;
}

export { getMaxModuleDepth };
//# sourceMappingURL=get-max-module-depth.js.map
